(function () {
  'use strict';

  var BRT_OFFSET_HOURS = 3; // America/Sao_Paulo, sem horário de verão desde 2019

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  // Retorna o instante (epoch ms) do próximo dia 10 às 00h no horário de Brasília.
  // Regra de negócio: venda vai do dia 10 de um mês até o dia 09 do mês seguinte,
  // encerrando exatamente na virada do dia 09 para o dia 10 (00h de Brasília).
  function getNextDeadline() {
    var nowUtcMs = Date.now();
    var brtNowMs = nowUtcMs - BRT_OFFSET_HOURS * 60 * 60 * 1000;
    var brtNow = new Date(brtNowMs);

    var day = brtNow.getUTCDate();
    var month = brtNow.getUTCMonth();
    var year = brtNow.getUTCFullYear();

    if (day >= 10) {
      month += 1;
    }

    // 00h de Brasília no dia 10 = 03h UTC do dia 10.
    return Date.UTC(year, month, 10, BRT_OFFSET_HOURS, 0, 0, 0);
  }

  function isDesignMode() {
    return window.Shopify && window.Shopify.designMode;
  }

  function initBar(bar) {
    if (bar.dataset.countdownInitialized === 'true') return;
    bar.dataset.countdownInitialized = 'true';

    var storageKey = 'countdown-bar-dismissed-' + (bar.dataset.countdownId || 'default');

    if (bar.dataset.dismissible === 'true') {
      // No editor de temas o fechamento é ignorado, senão o lojista que fechou a
      // faixa no preview não conseguiria mais vê-la ao personalizar.
      if (!isDesignMode()) {
        try {
          if (sessionStorage.getItem(storageKey) === '1') {
            bar.remove();
            return;
          }
        } catch (e) {
          // sessionStorage indisponível (modo privado etc.) — segue sem lembrar o fechamento
        }
      }

      var closeBtn = bar.querySelector('[data-countdown-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          try {
            sessionStorage.setItem(storageKey, '1');
          } catch (e) {}
          bar.remove();
        });
      }
    }

    var daysEl = bar.querySelector('[data-countdown-days]');
    var hoursEl = bar.querySelector('[data-countdown-hours]');
    var minutesEl = bar.querySelector('[data-countdown-minutes]');
    var secondsEl = bar.querySelector('[data-countdown-seconds]');
    var srEl = bar.querySelector('[data-countdown-sr-text]');

    var deadline = getNextDeadline();
    var lastAnnouncedMinute = null;
    var intervalId = null;

    function tick() {
      if (!bar.isConnected) {
        if (intervalId !== null) clearInterval(intervalId);
        return;
      }

      var now = Date.now();
      var distance = deadline - now;

      if (distance <= 0) {
        deadline = getNextDeadline();
        distance = deadline - now;
      }

      var totalSeconds = Math.floor(distance / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);

      if (srEl && minutes !== lastAnnouncedMinute) {
        lastAnnouncedMinute = minutes;
        srEl.textContent = 'Faltam ' + days + ' dias, ' + hours + ' horas e ' + minutes + ' minutos para o fim das inscrições deste título.';
      }
    }

    tick();
    intervalId = setInterval(tick, 1000);

    // Fallback do script inline da seção: garante a faixa visível caso ele não
    // tenha rodado (ex.: seção re-renderizada pelo editor de temas).
    bar.hidden = false;
  }

  function init(root) {
    var bars = (root || document).querySelectorAll('[data-countdown-bar]');
    bars.forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Editor de temas: re-renderizações da seção geram um novo DOM sem timer ativo.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
